// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-2NT5T07WZR';

/**
 * Helper function to delete a cookie by name
 */
const deleteCookie = (name, path = '/', domain = '') => {
    const domainPart = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}${domainPart}`;
};

/**
 * Delete all Google Analytics cookies
 */
const deleteGoogleAnalyticsCookies = () => {
    // Get all cookies
    const cookies = document.cookie.split(';');
    
    // List of GA cookie patterns
    const gaCookiePatterns = ['_ga', '_gid', '_gat', '_gat_gtag'];
    
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        
        // Check if cookie matches any GA pattern
        const isGACookie = gaCookiePatterns.some(pattern => cookieName.startsWith(pattern));
        
        if (isGACookie) {
            // Delete for current domain
            deleteCookie(cookieName);
            
            // Try to delete for parent domain as well
            const domain = window.location.hostname;
            const domainParts = domain.split('.');
            
            // Delete for .example.com if current domain is subdomain.example.com
            if (domainParts.length > 2) {
                const parentDomain = '.' + domainParts.slice(-2).join('.');
                deleteCookie(cookieName, '/', parentDomain);
            }
            
            // Also try with full domain
            deleteCookie(cookieName, '/', '.' + domain);
            
            console.log(`Deleted GA cookie: ${cookieName}`);
        }
    });
};

/**
 * Load Google Analytics script dynamically
 */
export const loadGoogleAnalytics = () => {
    // Check if already loaded
    if (window.gtag || document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) {
        console.log('Google Analytics already loaded');
        return;
    }

    // Create and load gtag script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    script.id = 'google-analytics-script';
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);

    console.log('Google Analytics loaded');
};

/**
 * Remove/Disable Google Analytics
 */
export const removeGoogleAnalytics = () => {
    // Remove script tag
    const script = document.querySelector(`script[src*="googletagmanager.com/gtag"]`);
    if (script) {
        script.remove();
    }

    // Remove inline script if exists
    const inlineScript = document.getElementById('google-analytics-script');
    if (inlineScript) {
        inlineScript.remove();
    }

    // Disable gtag
    if (window.gtag) {
        window['ga-disable-' + GA_MEASUREMENT_ID] = true;
        delete window.gtag;
    }

    // Clear dataLayer
    if (window.dataLayer) {
        window.dataLayer = [];
    }

    // Delete all Google Analytics cookies
    deleteGoogleAnalyticsCookies();

    console.log('Google Analytics disabled, removed, and cookies deleted');
};

/**
 * Check if Google Analytics is currently loaded
 */
export const isGoogleAnalyticsLoaded = () => {
    return !!(window.gtag && document.querySelector(`script[src*="googletagmanager.com/gtag"]`));
};

/**
 * Check user's cookie consent and apply analytics accordingly
 */
export const applyAnalyticsConsent = () => {
    try {
        const consentData = localStorage.getItem('cookie-consent');
        
        if (!consentData) {
            // No consent data yet - load analytics by default
            loadGoogleAnalytics();
            return;
        }

        const { choice } = JSON.parse(consentData);
        
        if (choice === 'accepted') {
            loadGoogleAnalytics();
        } else if (choice === 'denied') {
            removeGoogleAnalytics();
        }
    } catch (error) {
        console.error('Error applying analytics consent:', error);
        // On error, load analytics by default
        loadGoogleAnalytics();
    }
};
